<template>
  <div class="rank_new">
    <div class="new_header">
      <div class="header_title">
        <h2>新着</h2>
        <!-- <p class="header_value">2021/10/11~</p> -->
      </div>
    </div>
    <div class="new_list_wrapper">
      <ul class="new_list slider">
        <li class="item" v-for="(item, index) in new_posts.data" :key="index">
          <button
            class="item_title"
            @click="
              $router.push({ name: 'Challenge', params: { cid: item.id } })
            "
          >
            {{ item.data.name }}
          </button>
          <div class="item_div">
            <div class="item_graph">
              <div class="graph_img" style="transform: rotate(-90deg)">
                <svg
                  height="100%"
                  viewBox="0 0 20 20"
                  width="100%"
                  style="overflow: visible"
                >
                  <circle
                    cx="50%"
                    cy="50%"
                    fill="none"
                    stroke-width="1"
                    r="9"
                    stroke="#E6EAE6"
                  />
                  <circle
                    cx="50%"
                    cy="50%"
                    fill="none"
                    stroke-width="1"
                    r="9"
                    stroke="#F18D5F"
                    stroke-linecap="round"
                    :style="`stroke-dashoffset:${graph_num(
                      item
                    )};stroke-dasharray: 56.5487`"
                  />
                </svg>
              </div>
              <p class="graph_percentage">
                <span>{{ graph_percent(item) }}</span
                >%
              </p>
              <div class="graph_detail">
                <p>今のペース</p>
                <p class="fraction">
                  <span>{{ graph_mai(item) }}</span
                  >枚/<span>{{ graph_day(item) }}</span
                  >日
                </p>
              </div>
              <button
                class="graph_btn_icon"
                @click="
                  $route.params.userId == item.data.host
                    ? false
                    : $router.push({
                        name: 'User',
                        params: {
                          userId: item.data.host,
                        },
                      })
                "
              >
                <p>
                  <img
                    :src="new_posts.user[index].icon"
                    :alt="new_posts.user[index].name"
                  />
                </p>
              </button>
            </div>
          </div>
          <button
            class="item_btn_cheer"
            @click="
              maiSend(
                uid,
                uname,
                item.data.host,
                new_posts.user[index].name,
                item.id
              )
            "
            :disabled="sendMai"
          >
            <p>応援</p>
            <i class="fas fa-rocket"></i>
          </button>
          <!-- <button class="item_btn_chip">
            <img src="./../../assets/svg/item_chip.svg" alt="" />
          </button> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import firebaseUtil from "@/firebase";

export default {
  props: ["uid", "uname"],
  data() {
    return {
      new_posts: {
        user: [],
        data: [],
      },
      sendMai: false,
    };
  },
  mounted() {
    firebaseUtil.getNewPosts().then((data) => {
      let users = [];
      let getProfile = Promise.resolve();
      for (let i = 0; i < data.length; i++) {
        getProfile = getProfile.then(get.bind(this, data[i].host));
      }
      function get(uid) {
        return new Promise((resolve) => {
          firebaseUtil.getOtherProfile(uid).then((data) => {
            users.push(data);
            resolve();
          });
        });
      }
      getProfile.then(() => {
        this.new_posts.user = users;
        this.new_posts.data = data;
        console.log(this.new_posts);
      });
    });
  },
  methods: {
    graph_num(data) {
      let max = 56 - (56 / data.data.goal) * data.post;
      return max;
    },
    graph_percent(data) {
      return data.post == 0 ? 0 : (data.post / data.data.goal) * 100;
    },
    graph_mai(data) {
      // 結果
      return data.post;
    },
    graph_day(data) {
      // 結果
      let diff =
        new Date().getTime() - new Date(data.created.seconds * 1000).getTime();
      let between = Math.floor(diff / 86400000);
      return between;
    },
    displayTime(unixTime) {
      var date = new Date(unixTime);
      var diff = new Date().getTime() - date.getTime();
      var d = new Date(diff);

      if (d.getUTCFullYear() - 1970) {
        return d.getUTCFullYear() - 1970 + "年前";
      } else if (d.getUTCMonth()) {
        return d.getUTCMonth() + "ヶ月前";
      } else if (d.getUTCDate() - 1) {
        return d.getUTCDate() - 1 + "日前";
      } else if (d.getUTCHours()) {
        return d.getUTCHours() + "時間前";
      } else if (d.getUTCMinutes()) {
        return d.getUTCMinutes() + "分前";
      } else {
        return d.getUTCSeconds() + "秒前";
      }
    },
    maiSend(uid, name, to_uid, to_name, cid) {
      // maiを送れるのは1秒に一回まで
      let count = 1;
      firebaseUtil
        .setChallengeMai(uid, name, to_uid, to_name, cid, count)
        .then(() => {
          this.sendMai = true;
          setTimeout(() => {
            this.sendMai = false;
          }, 1000);
        });
    },
  },
};
</script>